import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, AutocompleteInput, ReferenceInput} from 'react-admin';
import {useTranslation} from "react-i18next";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
            <ReferenceInput
                source="media"
                reference="dictionary/medias"
                label={t('admin.media')}
            >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
        </EditGuesser>
    )
}

export default Edit
